<template>
  <div class="set-box">
    <p class="phone-text">手机号：<b>{{phone}}</b></p>
    <div class="set-input-box">
      <van-field class="set-input" v-model="tel" placeholder="请输入新手机号" maxlength="11"/>
    </div>
    <div class="set-input-box">
      <van-field class="set-input" v-model="code" placeholder="请输入验证码" maxlength="6"/>
      <van-button type="info" class="get-code2"  @click="getSms">{{codeText}}</van-button>
    </div>
    <van-button type="info" class="submit-btn" @click="setTel">确认修改</van-button>
  </div>
</template>

<script>
  import store from "../../store";

  export default {
    name: "setPhone",
    data() {
      return {
        phone:'',
        tel: '',
        code:'',
        codeText: '发送验证码', // 验证码文字
        id: null, // 计时器id
        timeId: null, // 一次性计时器id
      }
    },
    created() {
      this.phone = this.$store.state.user.phone
    },
    methods:{
      /*
      * 修改手机号
      * */
      setTel(){
        if (this.$tools.checkTel(this.tel)) {
          this.$toast('请输入正确的手机号')
          return
        }
        if (this.$tools.checkRequired(this.code)) {
          this.$toast('请输入验证码')
          return
        }
        this.$api.apiContent.setPhone({
          token: this.$store.state.user.token,
          oldPhone:this.phone,
          newPhone:this.tel,
          verifyCode:this.code
        }).then(() => {
          this.$toast('修改成功,请重新登录')
          setTimeout(()=>{
            sessionStorage.clear()
            localStorage.clear()
            store.user = null
            window.location.href = '/phoneLogin'
          },1000)
        }).catch(e => {
          this.$toast(e.msg)
        })
      },
      /*
      * 获取验证码
      * */
      getSms(){
        if (this.$tools.checkTel(this.tel)) {
          this.$toast('请输入正确的手机号')
          return
        }
        if (this.codeText === '发送验证码' || this.codeText === '重新发送') {
          let num = 60
          this.id = setInterval(() => {
            if (num === 0) {
              clearInterval(this.id)
              this.codeText = '重新发送'
              return
            }
            num--
            this.codeText = "重新发送(" + num + "s)"
          }, 1000)
          this.$api.apiContent.send({
            phone: this.tel,
          }).then().catch(e => {
            this.$toast(e.info)
            this.codeText = '重新发送'
            clearInterval(this.id)
          })
        }
      }
    }
  }
</script>

<style scoped lang="scss">
.set-box{
  padding: 30px 20px;
  .phone-text{
    text-align: center;
    font-size: 20px;
    line-height: 32px;
    margin-bottom: 20px;
    b{
      font-size: 18px;
    }
  }
  .set-input-box{
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    border-bottom: 1px solid #f0f0f0;
    height: 55px;
    .set-input{
      flex: 1;
    }
    .get-code2{
      width: 81px;
      height: 27px;
      padding: 0;
      border:0;

      background: #fff;
      border-radius: 13px;
      span{
        width: 81px;
        height: 27px;
        padding: 0;
        text-align: center;
        line-height: 27px;
        font-size: 16px;
        color: #2b8ee3;
      }
    }
  }
  .submit-btn{
    display: block;
    margin: 40px auto;
    width: 247px;
    height: 46px;
    background-color: #2b8ee3;
    border-radius: 5px;
    span{
      font-size: 18px;
    }
  }
}
</style>